import {React, useState} from 'react';
import {ButtonSet, Button, Theme, Loading, Grid, Stack, InlineNotification, TextInput, Column} from '@carbon/react';
import {useForm} from "react-hook-form";
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from "yup";

const schema_conReg = yup.object().shape({
  txtCodigo: yup.string().required("Este campo es requerido.")
                 .matches(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                  "El código es un campo numérico."),
  txtContrasenia: yup.string().required("Este campo es requerido.").matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\-])(?=.{8,})/,
                "Debe contener mínimo 8 caracteres e incluir una letra mayuscula, una letra minuscula, un número y un caracter especial."),
  txtConfContrasenia: yup.string().oneOf([yup.ref("txtContrasenia"), null],"Las contraseñas no son iguales.").required("Confirmar contraseña.")
})


const NuevoPassword = () => {
  let headers = new Headers(); headers.append('Content-Type', 'application/json');
  const [loading, setLoading] = useState(false);
  const {register, handleSubmit, formState:{ errors }} = useForm({
      resolver: yupResolver(schema_conReg)
  });

  const [errorNuevoPass, setErrorNuevoPass] = useState([]);
  const hideMesgNuevoPass = () => {
    setErrorNuevoPass({ "showMsg": 0 });
  }

  const submitForm = (nuevoPassForm) =>{
    setLoading(true);
    const npReq = {};
    npReq.Codigo = nuevoPassForm.txtCodigo;
    npReq.Password = nuevoPassForm.txtContrasenia;

    try{
      fetch(process.env.REACT_APP_URL_SERVICE_CAMBIAR_CONTRASENIA, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(npReq)
      }).then((res) => res.json()).then((resp) => {
          if(resp.Estatus === 0){
            setErrorNuevoPass({ "showMsg": 1, "kind":"success", "Mensaje": resp.Mensaje});
            setTimeout(() => {
              window.location.href = `/#/`;
            }, 4000);
          } else {
            setErrorNuevoPass({ "showMsg": 1, "kind":"error", "Mensaje": resp.Mensaje})
            setLoading(false);
          }
      });
    } catch(err) {
      console.log("Error al cambiar contraseña: ", err);
      setLoading(false);
    }  
  };
  
  return (
      <Theme theme="g100">
        <Loading className={'some-class'} active={loading} withOverlay={true} />
        <Grid className="nuevoPass-container">
          <Column lg={16} md={8} sm={4}>
            <h1 style={{ margin: '15px 0 20px' }}>Crear nueva contraseña.</h1>
            <br/><br/>
            <form  style={{ maxWidth: '500px' }} onSubmit={handleSubmit(submitForm)}>
              <Stack gap={5}>
                <TextInput id="txtCodigo" 
                    type="text" 
                    maxLength="10"
                    placeholder="Ingresa el código" 
                    labelText="Código de verificación *" 
                    {...register("txtCodigo")}
                    invalid={errors.txtCodigo} 
                    invalidText={errors.txtCodigo?.message}
                />
                <TextInput.PasswordInput id="txtContrasenia" 
                      type="password"  maxLength="50"
                      placeholder="Ingresa tu contraseña" 
                      labelText="Contraseña *" 
                      {...register("txtContrasenia")}
                      invalid={errors.txtContrasenia} 
                      invalidText={errors.txtContrasenia?.message} />
                    <TextInput.PasswordInput id="txtConfContrasenia" 
                      type="password" maxLength="50" 
                      placeholder="Confirma contraseña" 
                      labelText="Confirma contraseña *" 
                      {...register("txtConfContrasenia")}
                      invalid={errors.txtConfContrasenia} 
                      invalidText={errors.txtConfContrasenia?.message} />
                <div style={{ marginTop: '1rem'}}>
                  <ButtonSet>
                    <Button type="button" kind="secondary" href="/#/" style={{ maxWidth: '48%' }}>
                      Cancelar
                    </Button>
                    &nbsp; &nbsp;
                    <Button type="submit" kind="primary" style={{ maxWidth: '48%' }}>
                      Aceptar
                    </Button>
                  </ButtonSet>
                </div>
              </Stack>
            </form>
            <br/><br/>
                {errorNuevoPass.showMsg === 1 && 
                  <InlineNotification
                    title={errorNuevoPass.Mensaje}
                    kind={errorNuevoPass.kind}
                    style={{ maxWidth: '41%' }}
                    lowContrast={true} 
                    onClick={hideMesgNuevoPass}
                  />
                }
          </Column>
          <Column lg={16} md={8} sm={4}> <br/><br/> </Column>
        </Grid>
      </Theme>
  );
};

export default NuevoPassword;